export const STATUS_META = {
  pending: { label: "Pendiente", cls: "bg-amber-50 text-amber-600 border-amber-200" },
  confirmed: { label: "Confirmada", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  arrived: { label: "En sala", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  in_progress: { label: "En consulta", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  completed: { label: "Completada", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  cancelled: { label: "Cancelada", cls: "bg-red-50 text-red-500 border-red-200" },
  no_show: { label: "No asistió", cls: "bg-red-50 text-red-500 border-red-200" },
  approved: { label: "Aprobada", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  rejected: { label: "Rechazada", cls: "bg-red-50 text-red-500 border-red-200" },
};

export default function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-500 border-slate-200" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
}
